<template>
  <v-row>
    <v-col>
      <v-card class="mx-auto px-5 py-5" width="1300" outlined>
        <v-row>
          <v-col>
            <v-simple-table fixed-header dense height="200">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" colspan="2">
                      <span class="text-h5 font-weight-bold black--text"
                        >Historico do Pedido</span
                      >
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td width="30px">-</td>
                    <td class="column-description">
                      Ultima Atualização em
                      {{ order.updated_at | datetimeFormatBr }}
                    </td>
                  </tr>
                  <tr>
                    <td width="30px">-</td>
                    <td class="column-description">
                      Pedido criado em {{ order.created_at | datetimeFormatBr }}
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    order: {},
  },
};
</script>

<style scoped>
.column-description {
  padding: 20px !important;
  font-weight: bold;
}
</style>
